// **React Imports
import React, { Fragment, memo, useCallback, useMemo, useState } from 'react'

// **MUI Imports
import { ExpandMore, Workspaces } from '@mui/icons-material'
import { Box, Menu, MenuItem, Typography, styled } from '@mui/material'

// **API Imports

// **Redux Imports
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedWorkspace } from '../../../store/slice/workspace'

// **SCSS Imports
import { SUBSCRIPTION_PLANS } from '../../../utils/constant'
import './index.scss'

// **Styled Component
const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  '&.selected': {
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.primary.main,

    '&:hover': {
      backgroundColor: theme.palette.primary.main
    },
    '&:hover .MuiBox-root, &:hover .MuiBox-root svg': {
      color: `${theme.palette.common.white} !important`
    },
    p: { color: `${theme.palette.common.white} !important` }
  },
  '&:hover .MuiBox-root, &:hover .MuiBox-root svg': {
    color: theme.palette.text.primary
  }
}))

// **static style

const styles = {
  px: 4,
  py: 1.75,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  '& svg': {
    fontSize: '1.5rem',
    color: 'text.secondary'
  }
}

const SwitchWorkspace = (props) => {
  // props
  const { drawerExpanded, currentlyActivePlan } = props
  //Hooks
  const dispatch = useDispatch()

  //Redux State
  const workspaces = useSelector((state) => state.workspace.workspaces)
  const selectedWorkspace = useSelector(
    (state) => state.workspace.selectedWorkspace
  )

  //State
  const [anchorEl, setAnchorEl] = useState(null)

  // Variable
  const isEnterprisePlan = useMemo(
    () => currentlyActivePlan?.planName === SUBSCRIPTION_PLANS?.ENTERPRISE,
    [currentlyActivePlan]
  )

  //handlers
  const handleOpen = useCallback((e) => {
    setAnchorEl(e.currentTarget)
  }, [])

  const handleClose = useCallback((e) => {
    setTimeout(() => {
      setAnchorEl(null)
    })
  }, [])

  const handleSwitchWorkspace = useCallback(
    (workspace) => {
      dispatch(setSelectedWorkspace({ selectedWorkspace: workspace }))
      window.location.reload()
    },
    [dispatch]
  )

  return isEnterprisePlan && workspaces?.length > 0 ? (
    <Fragment>
      <Box className="workspace-container" onClick={handleOpen}>
        <Workspaces className="icons" />
        <Typography
          className="ellipsis-text"
          {...(selectedWorkspace?.name
            ? { title: selectedWorkspace?.name }
            : {})}
          sx={drawerExpanded ? { opacity: 1 } : { opacity: 0 }}
        >
          {selectedWorkspace?.name || 'Select Workspace'}
        </Typography>
        <ExpandMore
          sx={drawerExpanded ? { opacity: 1 } : { opacity: 0 }}
          className="icons"
        />
      </Box>
      <Menu
        disableAutoFocusItem
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        sx={{
          '& .MuiMenu-paper': {
            minWidth: '230px',
            mt: 1.8
          }
        }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left'
        }}
      >
        {workspaces.map((workspace) => (
          <MenuItemStyled
            className={`${
              selectedWorkspace?.id === workspace.id ? 'selected' : ''
            }`}
            key={workspace.id}
            sx={{ p: 0 }}
            onClick={() => handleSwitchWorkspace(workspace)}
          >
            <Box sx={styles}>
              <Typography className="ellipsis-text" title={workspace.name}>
                {workspace.name}
              </Typography>
            </Box>
          </MenuItemStyled>
        ))}
      </Menu>
    </Fragment>
  ) : (
    <Fragment />
  )
}

export default memo(SwitchWorkspace)
